import {fromJS, Map} from 'immutable';
import CustomRouteReducer from '../model/CustomRouteReducer'
import { combineReducers } from 'redux-immutable';
import UserReducer  from '../model/User/reducer';
import EmployeeReducer  from '../model/Employee/reducer';
import CustomerReducer  from '../model/Customer/reducer';
import ConversationReducer from '../model/Conversation/reducer';
import SystemReducer from '../model/System/reducer';
import FAQReducer from '../model/FAQ/reducer';
import CompanyReducer from '../model/Company/reducer';
import QuickResponseReducer from '../model/QuickResponse/reducer';
import Customization from '../model/Customization/reducer';
import AutoMessageReducer from '../model/AutoMessage/reducer';
import NotificationReducer from '../model/Notification/reducer';
import TutorialReducer from '../model/Tutorial/reducer';
import FeedbackReducer from '../model/Feedback/reducer';
import ExchangeReducer from '../model/Exchange/reducer';
import NetworkReducer from '../model/Network/reducer';
import PaymentReducer from '../model/Payment/reducer';

const appReducer = combineReducers({
  system: SystemReducer,
  routing: CustomRouteReducer,
  user: UserReducer,
  conversation: ConversationReducer,
  customer: CustomerReducer,
  notification: NotificationReducer,
  employee: EmployeeReducer,
  faq: FAQReducer,
  company: CompanyReducer,
  quickResponse: QuickResponseReducer,
  customization: Customization,
  automessage: AutoMessageReducer,
  tutorial: TutorialReducer,
  feedback: FeedbackReducer,
  exchange: ExchangeReducer,
  network : (state=Map(), action)=>{return state}, //HACK: hey, they require this random thing here, otherwise the thing complain, lol
  payment: PaymentReducer
})


const rootReducer = (state = Map(), action) => {

  if (action.type === 'USER_LOGOUT') {
      let url = state.getIn(['system', 'api'])
      var stateJS = {
          'system': {
              'api': url
          }
      }
      state = fromJS(stateJS)
  }

  var networkState = NetworkReducer(state.get('network'), action)
  state = state.set('network', networkState)
  return  appReducer(state, action)
}

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/rootReducer.js